import { render } from "./CBoatSpecFilter.vue?vue&type=template&id=5dd9a911&scoped=true"
import script from "./CBoatSpecFilter.vue?vue&type=script&lang=js"
export * from "./CBoatSpecFilter.vue?vue&type=script&lang=js"

import "./CBoatSpecFilter.vue?vue&type=style&index=0&id=5dd9a911&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd9a911"]])

export default __exports__